export default {
  forbidden_title: '403 - Accès interdit',
  forbidden_message: "Vous n'êtes pas autorisé(e) à consulter cette page."
};
